import { BaseAPI } from './axios';

const accountService = new BaseAPI();

export {
  accountService
}
